import { Tooltip } from '@mui/material';
import UntitledIcon from '@payaca/untitled-icons';
import React, { FC } from 'react';
import './DashboardActionRequiredItem.sass';

interface Props {
  isFlagged?: boolean;
  tooltipContent?: string;
  content?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const DashboardActionRequiredItem: FC<Props> = ({
  isFlagged,
  tooltipContent,
  content,
  onClick,
  className,
}: Props) => {
  return (
    <div
      className={`dashboard-action-required-item ${
        className ? className : ''
      } ${isFlagged ? 'flagged' : ''} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      <Tooltip
        title={tooltipContent || ''}
        arrow
        placement="top"
        PopperProps={{
          className: `dashboard-action-required-item-tooltip MuiTooltip-popper MuiTooltip-popperArrow ${
            isFlagged ? 'flagged' : ''
          } ${onClick ? 'clickable' : ''}`,
        }}
      >
        <div>
          {isFlagged && (
            <UntitledIcon className="alert-icon" name="info-circle.3" />
          )}

          <div className="content-wrapper">{content}</div>
        </div>
      </Tooltip>
    </div>
  );
};

export default DashboardActionRequiredItem;
